import "../plugins/splide.min.js";

export const carouselTypeValues = {
    slide: 'slide',
    loop: 'loop',
    fade: 'fade',
}

export function getDefaultOptions() {
    return {
        splide: {
            mainClassName: `splide`,
            carouselContainerClassName: `pdt`,
            carouselContainerSelector: `.splide.pdt`,
            carouselSlideClassName: `splide__slide`,
            noCarouselClassName: `no-carousel`,
            slidePerPage: 3,
            slidePerMove: 1,
            pagination: false,
            padding: 0,
            type: 'slide',
            showArrows: true,
            breakpoints: {
                767: {
                    perPage: 1,
                    padding: { right: '11%' },
                    pagination: true,
                },
                1059: {
                    perPage: 2,
                    padding: 0,
                    pagination: true,
                },
            },
            i18texts: {
                previous: `Prodotto precedente`,
                next: `Prodotto successivo`,
                first: `Vai al primo prodotto`,
                last: `Vai all'ultimo prodotto`,
                carousel: `Galleria dei prodotti Agos`,
            },
        },
        disableCarouselIfSlideCountIsLessThan: null,
    }
}

export function initialize(_options = getDefaultOptions()) {
    console.log("Initialize the carousel.");

    const options = _options;

    const splideContainer = document.querySelector(options.splide.carouselContainerSelector);
    if (!splideContainer) {
        console.warn("No splide container was found.");
        return;
    }

    const slides = document.querySelectorAll(`${options.splide.carouselContainerSelector} .${options.splide.carouselSlideClassName}`)
    if (!slides) {
        console.warn("No slide was found.");
        return;
    }

    const slidesCount = slides.length;
    if (slidesCount === 0) {
        console.warn("No slides were found.");
        return;
    }

    if (options.disableCarouselIfSlideCountIsLessThan != null && 
        window.innerWidth >= 768 && slidesCount < options.disableCarouselIfSlideCountIsLessThan
    ) {
        splideContainer.classList.add(options.splide.noCarouselClassName);
    }
    else {
        splideContainer.classList.remove(options.splide.noCarouselClassName);

        let splide = new Splide(options.splide.carouselContainerSelector, {
            perPage: options.splide.slidePerPage,
            perMove: options.splide.slidePerMove,
            pagination: options.splide.pagination,
            padding: options.splide.padding,
            type: options.splide.type,
            arrows: options.splide.showArrows,
            breakpoints: options.splide.breakpoints,
            i18n: {
                prev: options.splide.i18texts.previous,
                next: options.splide.i18texts.next,
                first: options.splide.i18texts.first,
                last: options.splide.i18texts.last,
                carousel: options.splide.i18texts.carousel,
            }
        });

        splide.mount();
    }
    
    console.log("Carousel initialized.");
}